import { UndefinedOption } from '@df/ui/atomic/atomic-options';
import { NICmsContentField } from '@icms/core/content';
import { ICONS_CODEPOINTS } from '../../../../../styles/icons';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const atomic = require('atomicConfig'); // alias setup in webpack

/**
 * Grid size options list
 */
export const GRID_SIZE_OPTIONS: NICmsContentField.IOption[] = [
    { key: 12, title: '1' },
    { key: 6, title: '2' },
    { key: 4, title: '3' },
    { key: 3, title: '4' },
    { key: 2, title: '6' },
    { key: 1, title: '12' }
];

const icons = Object.keys(ICONS_CODEPOINTS).map(iconKey => {
    return {
        key: `icon-${iconKey}`,
        title: iconKey
    };
});

export const ICONS_OPTIONS: NICmsContentField.IOption[] = [...UndefinedOption, ...icons];
export const presetColors = Object.values(atomic.config.namedColor) as NICmsContentField.IOption[];

export const FormSizeOptions = [
    { key: 'small', title: 'Small' },
    { key: 'medium', title: 'Medium' },
    { key: 'large', title: 'Large' }
];
